var render = function render(_c,_vm){return _c('div',{staticClass:"preparation-stage"},[_c('img',{staticClass:"icon",attrs:{"src":require('@assets/icon_password.svg'),"aria-hidden":"true"}}),_vm._m(0),_c('span',{staticClass:"wait-message"},[_vm._v(" Aproveite o seu período teste de 7 dias para ver como a Convenia pode facilitar a sua rotina de RH. ")])])
}
var staticRenderFns = [function (_c,_vm){return _c('span',{staticClass:"heading"},[_vm._v(" Estamos preparando tudo "),_c('span',{staticClass:"dot"})])
}]

export { render, staticRenderFns }